import styled from 'styled-components';

import Anchor from '../../atoms/Anchor';

export default styled(Anchor)`
  margin-right: 15px;
`;
